export default [
    {
        links: [
            {
                href: 'https://api.trustpilot.com/v1/reviews/6442b7cd746ca7dfea0e066c',
                method: 'GET',
                rel: 'reviews',
            },
            {
                href: 'https://api.trustpilot.com/v1/reviews/6442b7cd746ca7dfea0e066c/web-links',
                method: 'GET',
                rel: 'reviews-web-links',
            },
            {
                href: 'https://api.trustpilot.com/v1/resources/images/stars/5',
                method: 'GET',
                rel: 'resources-images-stars',
            },
        ],
        id: '6442b7cd746ca7dfea0e066c',
        consumer: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/consumers/6442b7cb6ce5cc001292a870',
                    method: 'GET',
                    rel: 'consumers',
                },
            ],
            id: '6442b7cb6ce5cc001292a870',
            displayName: 'Mary Diaz',
            displayLocation: null,
            numberOfReviews: 1,
        },
        businessUnit: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/business-units/5192fe2c00006400052c7f0a',
                    method: 'GET',
                    rel: 'business-units',
                },
            ],
            id: '5192fe2c00006400052c7f0a',
            identifyingName: 'ehealthmedicare.com',
            displayName: 'eHealth Medicare',
        },
        location: null,
        stars: 5,
        title: 'Very patient and informative great…',
        text: 'Very patient and informative great customer service',
        language: 'en',
        createdAt: '2023-04-21T18:20:29Z',
        experiencedAt: '2023-04-01T06:00:00Z',
        updatedAt: null,
        companyReply: null,
        isVerified: true,
        source: 'InvitationLinkApi',
        numberOfLikes: 0,
        status: 'active',
        reportData: null,
        complianceLabels: [],
        countsTowardsTrustScore: true,
        countsTowardsLocationTrustScore: null,
        invitation: null,
        businessUnitHistory: [],
        reviewVerificationLevel: 'invited',
    },
    {
        links: [
            {
                href: 'https://api.trustpilot.com/v1/reviews/64400878734f97e68fa136b9',
                method: 'GET',
                rel: 'reviews',
            },
            {
                href: 'https://api.trustpilot.com/v1/reviews/64400878734f97e68fa136b9/web-links',
                method: 'GET',
                rel: 'reviews-web-links',
            },
            {
                href: 'https://api.trustpilot.com/v1/resources/images/stars/5',
                method: 'GET',
                rel: 'resources-images-stars',
            },
        ],
        id: '64400878734f97e68fa136b9',
        consumer: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/consumers/64400877bb7d840012ebbc69',
                    method: 'GET',
                    rel: 'consumers',
                },
            ],
            id: '64400877bb7d840012ebbc69',
            displayName: 'Marjorie Rankin',
            displayLocation: null,
            numberOfReviews: 1,
        },
        businessUnit: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/business-units/5192fe2c00006400052c7f0a',
                    method: 'GET',
                    rel: 'business-units',
                },
            ],
            id: '5192fe2c00006400052c7f0a',
            identifyingName: 'ehealthmedicare.com',
            displayName: 'eHealth Medicare',
        },
        location: null,
        stars: 5,
        title: "The representative's are AWESOME.",
        text: "The representative's are AWESOME.\nThey were very helpful..I appreciate the representative's..",
        language: 'en',
        createdAt: '2023-04-19T17:27:52Z',
        experiencedAt: '2023-04-18T04:00:00Z',
        updatedAt: null,
        companyReply: null,
        isVerified: true,
        source: 'InvitationLinkApi',
        numberOfLikes: 0,
        status: 'active',
        reportData: null,
        complianceLabels: [],
        countsTowardsTrustScore: true,
        countsTowardsLocationTrustScore: null,
        invitation: null,
        businessUnitHistory: [],
        reviewVerificationLevel: 'invited',
    },
    {
        links: [
            {
                href: 'https://api.trustpilot.com/v1/reviews/6436c55e746ca7dfea07f665',
                method: 'GET',
                rel: 'reviews',
            },
            {
                href: 'https://api.trustpilot.com/v1/reviews/6436c55e746ca7dfea07f665/web-links',
                method: 'GET',
                rel: 'reviews-web-links',
            },
            {
                href: 'https://api.trustpilot.com/v1/resources/images/stars/5',
                method: 'GET',
                rel: 'resources-images-stars',
            },
        ],
        id: '6436c55e746ca7dfea07f665',
        consumer: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/consumers/6436c55cf773970012471fb2',
                    method: 'GET',
                    rel: 'consumers',
                },
            ],
            id: '6436c55cf773970012471fb2',
            displayName: 'Bethel Cole',
            displayLocation: null,
            numberOfReviews: 1,
        },
        businessUnit: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/business-units/5192fe2c00006400052c7f0a',
                    method: 'GET',
                    rel: 'business-units',
                },
            ],
            id: '5192fe2c00006400052c7f0a',
            identifyingName: 'ehealthmedicare.com',
            displayName: 'eHealth Medicare',
        },
        location: null,
        stars: 5,
        title: 'It is important for the agents to be patient and knowledgeable of the plan and services.',
        text: "The agent's helpfulness and knowledge made it so beneficial for me.  Yes, I am impressed with the agent's manner and expertise.",
        language: 'en',
        createdAt: '2023-04-12T16:51:11Z',
        experiencedAt: '2023-04-06T05:00:00Z',
        updatedAt: null,
        companyReply: null,
        isVerified: true,
        source: 'InvitationLinkApi',
        numberOfLikes: 0,
        status: 'active',
        reportData: null,
        complianceLabels: [],
        countsTowardsTrustScore: true,
        countsTowardsLocationTrustScore: null,
        invitation: null,
        businessUnitHistory: [],
        reviewVerificationLevel: 'invited',
    },
    {
        links: [
            {
                href: 'https://api.trustpilot.com/v1/reviews/64349f72734f97e68f9b6495',
                method: 'GET',
                rel: 'reviews',
            },
            {
                href: 'https://api.trustpilot.com/v1/reviews/64349f72734f97e68f9b6495/web-links',
                method: 'GET',
                rel: 'reviews-web-links',
            },
            {
                href: 'https://api.trustpilot.com/v1/resources/images/stars/5',
                method: 'GET',
                rel: 'resources-images-stars',
            },
        ],
        id: '64349f72734f97e68f9b6495',
        consumer: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/consumers/63717a71d4a01e0012a51ef3',
                    method: 'GET',
                    rel: 'consumers',
                },
                {
                    href: 'https://user-images.trustpilot.com/63717a71d4a01e0012a51ef3/73x73.png',
                    method: 'GET',
                    rel: 'profile-image',
                },
            ],
            id: '63717a71d4a01e0012a51ef3',
            displayName: 'Brenda Taylor',
            displayLocation: null,
            numberOfReviews: 3,
        },
        businessUnit: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/business-units/5192fe2c00006400052c7f0a',
                    method: 'GET',
                    rel: 'business-units',
                },
            ],
            id: '5192fe2c00006400052c7f0a',
            identifyingName: 'ehealthmedicare.com',
            displayName: 'eHealth Medicare',
        },
        location: null,
        stars: 5,
        title: 'Caring compassionate agents that was…',
        text: 'Caring compassionate agents that was very professional and kind as she went above and beyond to give the options available to me in my area. 04/07/23.',
        language: 'en',
        createdAt: '2023-04-11T01:44:50Z',
        experiencedAt: '2023-04-07T04:00:00Z',
        updatedAt: null,
        companyReply: null,
        isVerified: true,
        source: 'InvitationLinkApi',
        numberOfLikes: 0,
        status: 'active',
        reportData: null,
        complianceLabels: [],
        countsTowardsTrustScore: true,
        countsTowardsLocationTrustScore: null,
        invitation: null,
        businessUnitHistory: [],
        reviewVerificationLevel: 'invited',
    },
    {
        links: [
            {
                href: 'https://api.trustpilot.com/v1/reviews/643457f4734f97e68f9b4660',
                method: 'GET',
                rel: 'reviews',
            },
            {
                href: 'https://api.trustpilot.com/v1/reviews/643457f4734f97e68f9b4660/web-links',
                method: 'GET',
                rel: 'reviews-web-links',
            },
            {
                href: 'https://api.trustpilot.com/v1/resources/images/stars/5',
                method: 'GET',
                rel: 'resources-images-stars',
            },
        ],
        id: '643457f4734f97e68f9b4660',
        consumer: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/consumers/643457f29ef0740012aa71ff',
                    method: 'GET',
                    rel: 'consumers',
                },
            ],
            id: '643457f29ef0740012aa71ff',
            displayName: 'Eric Lovell',
            displayLocation: null,
            numberOfReviews: 1,
        },
        businessUnit: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/business-units/5192fe2c00006400052c7f0a',
                    method: 'GET',
                    rel: 'business-units',
                },
            ],
            id: '5192fe2c00006400052c7f0a',
            identifyingName: 'ehealthmedicare.com',
            displayName: 'eHealth Medicare',
        },
        location: null,
        stars: 5,
        title: 'Explained all benefits well ,and all…',
        text: 'Explained all benefits well ,and all benefits that were included,where I can receive prescriptions,and doctors benefits,thank you very much!!',
        language: 'en',
        createdAt: '2023-04-10T20:39:48Z',
        experiencedAt: '2023-04-07T05:00:00Z',
        updatedAt: null,
        companyReply: null,
        isVerified: true,
        source: 'InvitationLinkApi',
        numberOfLikes: 0,
        status: 'active',
        reportData: null,
        complianceLabels: [],
        countsTowardsTrustScore: true,
        countsTowardsLocationTrustScore: null,
        invitation: null,
        businessUnitHistory: [],
        reviewVerificationLevel: 'invited',
    },
    {
        links: [
            {
                href: 'https://api.trustpilot.com/v1/reviews/6433aa72734f97e68f9adc80',
                method: 'GET',
                rel: 'reviews',
            },
            {
                href: 'https://api.trustpilot.com/v1/reviews/6433aa72734f97e68f9adc80/web-links',
                method: 'GET',
                rel: 'reviews-web-links',
            },
            {
                href: 'https://api.trustpilot.com/v1/resources/images/stars/5',
                method: 'GET',
                rel: 'resources-images-stars',
            },
        ],
        id: '6433aa72734f97e68f9adc80',
        consumer: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/consumers/6433aa715d1c3800149d6628',
                    method: 'GET',
                    rel: 'consumers',
                },
            ],
            id: '6433aa715d1c3800149d6628',
            displayName: 'David Teitelbaum',
            displayLocation: null,
            numberOfReviews: 1,
        },
        businessUnit: {
            links: [
                {
                    href: 'https://api.trustpilot.com/v1/business-units/5192fe2c00006400052c7f0a',
                    method: 'GET',
                    rel: 'business-units',
                },
            ],
            id: '5192fe2c00006400052c7f0a',
            identifyingName: 'ehealthmedicare.com',
            displayName: 'eHealth Medicare',
        },
        location: null,
        stars: 5,
        title: 'Friendly and personable representative',
        text: 'Friendly and personable representative',
        language: 'en',
        createdAt: '2023-04-10T08:19:30Z',
        experiencedAt: '2023-04-07T04:00:00Z',
        updatedAt: null,
        companyReply: null,
        isVerified: true,
        source: 'InvitationLinkApi',
        numberOfLikes: 0,
        status: 'active',
        reportData: null,
        complianceLabels: [],
        countsTowardsTrustScore: true,
        countsTowardsLocationTrustScore: null,
        invitation: null,
        businessUnitHistory: [],
        reviewVerificationLevel: 'invited',
    },
];
